import { create } from 'zustand';

export type AuthMode = 'sign-in' | 'sign-up' | 'forgot';

interface AuthDialogState {
  isOpen: boolean;
  mode: AuthMode;
  open: (mode?: AuthMode) => void;
  close: () => void;
  setMode: (mode: AuthMode) => void;
}

export const useAuthDialog = create<AuthDialogState>((set) => ({
  isOpen: false,
  mode: 'sign-in',
  open: (mode = 'sign-in') => set({ isOpen: true, mode }),
  close: () => set({ isOpen: false }),
  setMode: (mode) => set({ mode }),
}));
